module.exports = __webpack_public_path__ + "img/clock.d91c9f2d.svg";